import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_FUNCTION} from '../../metamodel/Concept';

export default class BusinessFunctionNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_FUNCTION;
	}
}
